import { defineAttrs as c } from "../../utils/typed-attrs.js";
const n = c({
  attributePath: { default: "" },
  fallback: { default: "" }
}), o = {
  inline: !0,
  attrs: n,
  group: "inline",
  selectable: !0,
  parseDOM: [
    {
      tag: "span.embercom-prosemirror-composer-template",
      getAttrs(e) {
        return {
          attributePath: e.getAttribute("data-template-identifier"),
          fallback: e.getAttribute("data-template-fallback")
        };
      }
    }
  ],
  toDOM(e) {
    const r = e.attrs, a = r.attributePath, s = r.fallback, t = e.type.spec.infoResolver, i = t == null ? void 0 : t.humanReadable(a), l = ["embercom-prosemirror-composer-template", "intercom-interblocks-template"];
    return t && !t.isValid(a) && l.push("invalid"), t != null && t.requiresFallback(a, s) && l.push("requires-fallback"), [
      "span",
      {
        class: l.join(" "),
        "data-template-identifier": a,
        "data-template-fallback": s
      },
      i
    ];
  }
};
export {
  o as templateSpec
};
